module.exports = __webpack_public_path__ + "media/images/font/Gustavo-Light-d2d9476eb07a91d94984a2ff5e9afc61.eot";